import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const WebPixelSettingKeys = createEnum([
  "COVERAGE_SPLIT",
  "CUSTOMER_ACCOUNTS",
  "CONCIERGE_SPLIT",
  "MARKETING",
  "EXPANDED_WARRANTY_SPLIT",
  "STOREFRONT_SALES_AI",
  "CONTEXTUAL",
]);

export const activateWebPixelSetting = {
  name: "activateWebPixelSetting" as const,
  input: z.object({ setting: WebPixelSettingKeys }),
  output: z.object({
    success: z.boolean(),
    settings: z.record(z.string(), z.boolean()),
  }),
};
